import { z } from "zod";

import { Pageable } from "@/core/types";

import { ConsultantProfileShort } from "./ConsultantProfileShort";

export const ConsultantProfilePageable = Pageable(ConsultantProfileShort);

export type ConsultantProfilePageable = z.infer<typeof ConsultantProfilePageable>;
